import {FC, useContext, useEffect} from 'react';
import {useRecoilStateLoadable} from 'recoil';
import {useNavigate, useParams} from 'react-router-dom';

import {Box, Button, Paper} from '@mui/material';
import {TaskLocationForm} from './TaskLocationForm';
import Fallback from '../../../../ui/fallback/Fallback';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import NotFoundErrorInsideComponent from '../../../../ui/not-found/NotFoundErrorInsideComponent';

import {EventBusContext} from '../../../../providers/EventBus';

import {taskLocationDictQueryByCodeFamily} from '../../../../store/taskLocations/selectors';

const TaskLocationCode: FC = () => {
  const {id} = useParams();
  const [{state: taskLocationState, contents: taskLocationContents}, setTaskLocation] = useRecoilStateLoadable(
    taskLocationDictQueryByCodeFamily(id),
  );
  const navigate = useNavigate();
  const {bus} = useContext(EventBusContext);

  const loading = taskLocationState === 'loading' || !taskLocationContents;

  useEffect(() => {
    taskLocationState === 'hasValue' && setTaskLocation(taskLocationContents);

    taskLocationState === 'hasError' && bus?.emit('error', [taskLocationContents]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskLocationState]);

  return loading ? (
    <div>
      <Fallback />
    </div>
  ) : taskLocationState === 'hasError' ? (
    <NotFoundErrorInsideComponent to="/dictionaries/taskLocations" />
  ) : (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '70%', margin: '0 auto', mt: 4, mb: 4, p: '8px 16px 16px 16px'}}>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <Button startIcon={<KeyboardReturnIcon />} onClick={() => navigate('/dictionaries/taskLocations')}>
            Назад
          </Button>
        </Box>
        <TaskLocationForm taskLocation={taskLocationContents} />
      </Paper>
    </Box>
  );
};

export default TaskLocationCode;
